import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { LocationFileUploadComponent } from "../../../file-upload/components/location-file-upload/location-file-upload.component";
import { PrimaryButtonComponent } from "../../../../shared/components/primary-button/primary-button.component";
import { Router } from '@angular/router';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { HistoricalDataInputDialogComponent } from "../historical-data-input-dialog/historical-data-input-dialog.component";

@Component({
  selector: 'app-add-missing-data',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, LocationFileUploadComponent, PrimaryButtonComponent, HistoricalDataInputDialogComponent],
  templateUrl: './add-missing-data.component.html',
  styleUrl: './add-missing-data.component.css'
})
export class AddMissingDataComponent {
  modalDialogId: string = 'dashboard_modal_add_missing_data'

  @Input() toast!: ToastComponent;

  @ViewChild(HistoricalDataInputDialogComponent) historicalData!: HistoricalDataInputDialogComponent;

  uploading: boolean = false;

  fileName: string = "A2A627672.pdf";
  precentage: number = 60;
  isModalOpen: boolean = false; 

  constructor(private router: Router) { }

  openModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      this.isModalOpen = true;
      modal.showModal();
    }
  }

  closeModal(): void {
    const modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    if (modal) {
      this.isModalOpen = false;
      modal.close();
    }
  }

  addDataClick() {
    this.closeModal();
    this.historicalData.openModal();
  }

}
